"use client";

import {
  MenubarRadioGroup,
  MenubarRadioItem,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
} from "@oreme/ui";
import { useTheme } from "next-themes";
import { useTranslations } from "next-intl";

function SharedMenubarSettingsTheme() {
  const t = useTranslations("global.MenubarSettingsTheme");
  const { theme, setTheme } = useTheme();

  const handleValueChange = (value: string): void => {
    setTheme(value);
  };

  return (
    <MenubarSub>
      <MenubarSubTrigger>{t("title")}</MenubarSubTrigger>
      <MenubarSubContent>
        <MenubarRadioGroup value={theme} onValueChange={handleValueChange}>
          <MenubarRadioItem value="system">{t("system")}</MenubarRadioItem>
          <MenubarRadioItem value="light">{t("light")}</MenubarRadioItem>
          <MenubarRadioItem value="dark">{t("dark")}</MenubarRadioItem>
        </MenubarRadioGroup>
      </MenubarSubContent>
    </MenubarSub>
  );
}

export { SharedMenubarSettingsTheme };
